module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-9.8098ab22.svg";